/* __next_internal_client_entry_do_not_use__ SDUIFilterablePaginatedSectionComponentsColumnNonRSC auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SDUIComponentRenderer } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/SDUIComponentRenderer/SDUIComponentRenderer";
import { SDUIFilterRowRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/FilterBar/SDUIFilterRowRenderer";
import { useFilterablePaginatedSectionQuery } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Fetching/useFilterablePaginatedSectionQuery";
import { SDUIFilterablePaginatedSectionFilterRowLoadingSkeleton } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/LoadingSkeleton/SDUIFilterablePaginatedSectionFilterRowLoadingSkeleton";
import { SDUIFilterablePaginatedSectionGridLoadingSkeleton } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/LoadingSkeleton/SDUIFilterablePaginatedSectionGridLoadingSkeleton";
import { ComponentsFlowLayoutSection } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/SectionComponentsColumn/__internal__/ComponentsFlowLayoutSection";
import { hubComponentRenderers } from "@faire/retailer-visitor-shared/views/category/HubsRSC/utils/hubComponentRenderers";
import { Column } from "@faire/web--source/slate/Layout";
import React from "react";
export var SDUIFilterablePaginatedSectionComponentsColumnNonRSC = function(param) {
    var filterablePaginatedSection = param.filterablePaginatedSection, componentRenderers = param.componentRenderers, sectionLoggingData = param.sectionLoggingData;
    var _useFilterablePaginatedSectionQuery = useFilterablePaginatedSectionQuery(filterablePaginatedSection), isFilterLoading = _useFilterablePaginatedSectionQuery.isFilterLoading, isFilteredComponentsFetching = _useFilterablePaginatedSectionQuery.isFilteredComponentsFetching, filteredComponentsData = _useFilterablePaginatedSectionQuery.filteredComponentsData, isFilteredComponentsError = _useFilterablePaginatedSectionQuery.isFilteredComponentsError;
    var filteredComponents = filteredComponentsData === null || filteredComponentsData === void 0 ? void 0 : filteredComponentsData.components;
    var filterBarComponent = filteredComponents === null || filteredComponents === void 0 ? void 0 : filteredComponents.find(function(component) {
        return component.filter_bar_component;
    });
    if (isFilteredComponentsFetching || isFilteredComponentsError) {
        return /*#__PURE__*/ _jsxs(Column, {
            style: {
                width: "100%",
                minWidth: 0
            },
            children: [
                filterBarComponent ? /*#__PURE__*/ _jsx(SDUIFilterRowRenderer, {
                    component: filterBarComponent,
                    sectionLoggingParams: sectionLoggingData,
                    isFilterLoading: isFilterLoading
                }, filterBarComponent.id) : /*#__PURE__*/ _jsx(SDUIFilterablePaginatedSectionFilterRowLoadingSkeleton, {}),
                /*#__PURE__*/ _jsx(SDUIFilterablePaginatedSectionGridLoadingSkeleton, {})
            ]
        });
    }
    if (filteredComponentsData === null || filteredComponentsData === void 0 ? void 0 : filteredComponentsData.layout) {
        return /*#__PURE__*/ _jsx(Column, {
            style: {
                width: "100%",
                minWidth: 0
            },
            children: /*#__PURE__*/ _jsx(ComponentsFlowLayoutSection, {
                filteredComponents: filteredComponentsData,
                componentRenderers: componentRenderers,
                sectionLoggingData: sectionLoggingData
            })
        });
    }
    return /*#__PURE__*/ _jsxs(Column, {
        style: {
            width: "100%",
            minWidth: 0
        },
        children: [
            filterBarComponent ? /*#__PURE__*/ _jsx(SDUIFilterRowRenderer, {
                component: filterBarComponent,
                sectionLoggingParams: sectionLoggingData,
                isFilterLoading: isFilterLoading
            }, filterBarComponent.id) : /*#__PURE__*/ _jsx(SDUIFilterablePaginatedSectionFilterRowLoadingSkeleton, {}),
            filteredComponents === null || filteredComponents === void 0 ? void 0 : filteredComponents.filter(function(component) {
                return !component.filter_bar_component;
            }).map(function(component) {
                return /*#__PURE__*/ _jsx(SDUIComponentRenderer, {
                    component: component,
                    componentRenderers: getComponentRenderers(componentRenderers),
                    sectionLoggingParams: sectionLoggingData,
                    isPrimaryContent: !!component.is_required_for_interactivity,
                    renderBehaviourOverrides: {
                        gridOptimizations: true
                    }
                }, component.id);
            })
        ]
    });
};
/**
 * This is a temporary fix since we cannot pass functions from the server to the FPS section renderer
 * (which is a client component)
 * This will be removed once we roll out RSC fully for FPS
 * see HubsViewLayoutRendererRSC.tsx for the other half of this
 */ var getComponentRenderers = function(componentRenderers) {
    return Object.keys(componentRenderers).length > 0 ? componentRenderers : hubComponentRenderers;
};
